// extracted by mini-css-extract-plugin
export var active = "_ae-7";
export var container = "_ae-0";
export var evenWidth = "_ae-4";
export var large = "_ae-5";
export var outlet = "_ae-8";
export var slide = "_ae-2";
export var small = "_ae-6";
export var tab = "_ae-3";
export var tabs = "_ae-1";